import React, { useState, useEffect } from "react";

import { Card, Typography, Pagination, Table, Popconfirm, message, Segmented } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { Tag, Tooltip, Space } from "antd";
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  UserAddOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { GetFormattedDateTime, GetSpacedSpan } from "../../../../components/utils/DateTimeUtils";
import BulkCourseUsersAdd from "../../../../components/AdminComponents/Modals/BulkCourseUsersAdd";
import BundleResetModal from "../../../../components/AdminComponents/Modals/BundleResetModal";
import { DeleteTwoTone } from "@ant-design/icons";
import axiosInstance from "../../../../api/Axios";
import UserViewExpandable from "./UserViewExpandable";

const { Title } = Typography;
const Users = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedView, setSelectedView] = useState("user");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [viewCounts, setViewCounts] = useState({
    user: 0,
    reset: 0,
    registration: 0,
  });

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/bundleuserlist/${id}/`,
    loadAgain: loadAgain,
    passFilterUrl: `view=${selectedView}`,
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const views = ["user", "reset", "registration"];
        const promises = views.map((v) =>
          axiosInstance.get(`learn/bundleuserlist/${id}/?view=${v}&page_size=1`)
        );
        const results = await Promise.all(promises);
        const counts = {};
        results.forEach((res, index) => {
          counts[views[index]] = res.data?.count || 0;
        });
        setViewCounts(counts);
      } catch (err) {
        console.error("Error fetching view counts:", err);
      }
    };
    fetchCounts();
  }, [id, loadAgain]);

  useEffect(() => {
    setFilterUrl(`view=${selectedView}`);
    setExpandedRowKeys([]);
  }, [selectedView, setFilterUrl]);
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Trainer has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove trainer.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/learn/bundleuserdelete/${record?.bundle_course_id}/${record?.id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const commonColumns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 135,
    },
    {
      title: "User Name",
      dataIndex: "full_name",
      key: "full_name",
      width: 140,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
  ];

  const actionsColumn = props?.ImpersonateAccess
    ? [
      {
        title: "Actions",
        dataIndex: "id",
        key: "id",
        align: "center",
        width: 100,
        fixed: "right",
        render: (text, record) =>
          record?.is_delete ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Popconfirm
                title={"Delete User"}
                description=" "
                onConfirm={() => handleDelete(record)}
                okText="Yes"
                cancelText="No"
                placement="leftTop"
              >
                <DeleteTwoTone
                  style={{
                    cursor: "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                  }}
                  title="Archive"
                  twoToneColor="#eb2f96"
                />
              </Popconfirm>
            </div>
          ) : null,
      },
    ]
    : [];

  const getColumns = () => {
    switch (selectedView) {
      case "reset":
        return [
          {
            title: "Next Reset Date",
            dataIndex: "next_run_date",
            key: "next_run_date",
            width: 200,
            render: GetFormattedDateTime,
          },
          {
            title: "Enrollment Count",
            dataIndex: "enrollment_count",
            key: "enrollment_count",
            width: 150,
          },
        ];
      case "registration":
        return [
          ...commonColumns,
          {
            title: "Registration ID",
            dataIndex: "assignment_id",
            key: "assignment_id",
            width: 140,
          },
          {
            title: "Course Name",
            dataIndex: "course_name",
            key: "course_name",
            width: 250,
          },
          {
            title: "Mode",
            dataIndex: "course_mode",
            key: "course_mode",
            width: 120,
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (status) => {
              const statusColors = {
                Enrolled: { color: "#1890ff", borderColor: "#91d5ff" },
                Started: { color: "#faad14", borderColor: "#ffe58f" },
                Completed: { color: "#52c41a", borderColor: "#b7eb8f" },
                Active: { color: "#52c41a", borderColor: "#b7eb8f" },
              };
              const style = statusColors[status] || { color: "#8c8c8c", borderColor: "#d9d9d9" };

              return (
                <Tag
                  style={{
                    color: style.color,
                    borderColor: style.borderColor,
                    backgroundColor: "transparent",
                    borderRadius: "20px",
                    fontWeight: "600",
                    paddingInline: "15px",
                    textAlign: "center",
                    minWidth: "75px",
                  }}
                >
                  {status}
                </Tag>
              );
            },
          },
          {
            title: "Enrollment Date",
            dataIndex: "enrollment_date",
            key: "enrollment_date",
            width: 150,
            render: GetFormattedDateTime,
          },
          {
            title: "Completion Date",
            dataIndex: "completion_date",
            key: "completion_date",
            width: 150,
            render: GetFormattedDateTime,
          },
        ];
      default:
        return [
          ...commonColumns,
          {
            title: "Progress Summary",
            key: "progress_summary",
            render: (text, record) => {
              const {
                completed_count,
                enroled_count,
                started_count,
                total_count,
              } = record;

              return (
                <Space size="small" direction="vertical">
                  <Space wrap>
                    <Tooltip title="Total Assigned">
                      <Tag
                        icon={<BarsOutlined />}
                        color="default"
                        style={{ fontSize: "13.25px" }}
                      >
                        {total_count}
                      </Tag>
                    </Tooltip>
                    <Tooltip title="Enrolled">
                      <Tag
                        icon={<UserAddOutlined style={{ color: "blue" }} />}
                        color="default"
                        style={{ fontSize: "13.25px" }}
                      >
                        {" "}
                        {enroled_count}
                      </Tag>
                    </Tooltip>
                    <Tooltip title="Started">
                      <Tag
                        icon={
                          <PlayCircleOutlined style={{ color: "#ec7a1c" }} />
                        }
                        color="default"
                        style={{ fontSize: "13.25px" }}
                      >
                        {" "}
                        {started_count}
                      </Tag>
                    </Tooltip>
                    <Tooltip title="Completed">
                      <Tag
                        icon={
                          <CheckCircleOutlined style={{ color: "green" }} />
                        }
                        color="default"
                        style={{ fontSize: "13.25px" }}
                      >
                        {" "}
                        {completed_count}
                      </Tag>
                    </Tooltip>
                  </Space>
                </Space>
              );
            },
            width: 280,
          },
          {
            title: "Department",
            dataIndex: "department_name",
            key: "department_name",
            width: 250,
            ellipsis: true,
          },
          {
            title: "Due Date",
            dataIndex: "due_date",
            key: "due_date",
            width: 150,
            render: GetFormattedDateTime,
          },
          ...actionsColumn,
        ];
    }
  };

  const columns = getColumns();

  const ResetEnrollmentsTable = ({ enrollments }) => {
    const enrollmentColumns = [
      {
        title: "User Name",
        dataIndex: "full_name",
        key: "full_name",
        width: 140,
        render: (text) => GetSpacedSpan(text),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 200,
        render: (text) => GetSpacedSpan(text),
      },
      {
        title: "Course Name",
        dataIndex: "course_name",
        key: "course_name",
        width: 250,
        render: (text) => GetSpacedSpan(text),
      },
      {
        title: "Department",
        dataIndex: "department_name",
        key: "department_name",
        width: 150,
        ellipsis: true,
        render: (text) => GetSpacedSpan(text),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        render: (text) => GetSpacedSpan(text),
      },
      {
        title: "Next Reset Date",
        dataIndex: "next_run_date",
        key: "next_run_date",
        width: 150,
        render: (text) => GetSpacedSpan(GetFormattedDateTime(text)),
      },
    ];
    return (
      <Card
        style={{ width: "100%", borderRadius: "8px", border: "1px solid #f0f0f0" }}
        bodyStyle={{ padding: "0px" }}
      >
        <CommonTopDetails
          title={`Enrollments`}
          titleSuffix={`${enrollments?.length || 0} user(s)`}
          showAddButton={false}
          filterAction={false}
          marginPass="10px"
          paddingInlinepass="15px"
          topSizeAdd="15px"
          variantPass={"sm"}
          showSearch={false}
        />
        <Table
          columns={enrollmentColumns}
          dataSource={enrollments}
          pagination={{
            pageSize: 10,
            size: "small",
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20"],
          }}
          size="small"
          bordered
          rowKey="id"
          className="table-container"
          style={{ margin: "15px" }}
          scroll={{ x: 800 }}
        />
      </Card>
    );
  };
  const { data: data2 } = useCommonListing({
    passSize: 100,
    passPage: 1,
    passURL: `learn/bundledetailslist/?bundle_id=${id}`,
  });
  console.log(data2);
  const FilterSlider = () => {
    const options = [
      { label: `Users (${viewCounts.user})`, value: "user" },
      { label: `Next Reset Info (${viewCounts.reset})`, value: "reset" },
      { label: `Registrations (${viewCounts.registration})`, value: "registration" },
    ];

    return (
      <div className="filter-slider-container">
        <style>
          {`
                        .filter-slider-container .ant-segmented {
                            background: #D9D9D9;
                            border-radius: 10px;
                            padding: 4px;
                        }
                        .filter-slider-container .ant-segmented-item {
                            border-radius: 8px;
                            transition: all 0.3s;
                        }
                        .filter-slider-container .ant-segmented-item-selected {
                            background: #254061 !important;
                            color: #fff !important;
                        }
                        .filter-slider-container .ant-segmented-item:not(.ant-segmented-item-selected) {
                            color: #3F3F3F;
                        }
                        .filter-slider-container .ant-segmented-item-label {
                            padding: 4px 16px;
                            font-weight: 500;
                            font-size: 14px;
                        }
                    `}
        </style>
        <Segmented
          options={options}
          value={selectedView}
          onChange={setSelectedView}
        />
      </div>
    );
  };
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Users Summary
      </Title>
      {/* ! removing this before moving to production need to braing back this in staging  */}
      <CommonTopDetails
        title={`Bundle Registrations`}
       // leftContent={<FilterSlider />}
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () =>
            selectedView === "reset"
              ? setIsResetModalOpen(true)
              : setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id || record.next_run_date}
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 400,
        }}
        bordered
        expandable={
          selectedView === "reset"
            ? {
              expandedRowRender: (record) => (
                <ResetEnrollmentsTable enrollments={record.enrollments} />
              ),
              rowExpandable: (record) => record.enrollments?.length > 0,
              expandedRowKeys: expandedRowKeys,
              onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
            }
            : selectedView === "user"
              ? {
                expandedRowRender: (record) => (
                  <UserViewExpandable record={record} id={id} />
                ),
                rowExpandable: (record) => true,
                expandedRowKeys: expandedRowKeys,
                onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
              }
              : undefined
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkCourseUsersAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        course_ids={data2?.map((id) => id?.child_course_id) || []}
        from="bundle"
        bundle_id={id}
        ShowMessage={props?.data1?.user_count > 0 ? true : false}
      />
      <BundleResetModal
        open={isResetModalOpen}
        onClose={() => setIsResetModalOpen(false)}
        data1={props?.data1}
        onApply={() => {
          props?.LoadUser();
          LoadAPI();
        }}
      />
    </Card>
  );
};

export default Users;
